// TODO: VL-6033 - re-write the vl_chat FE by FE engineers
import React, { useState } from 'react';
import { AssistantMessageProps, useChatContext, Markdown } from '@copilotkit/react-ui';
import styles from './CustomAssistantMessage.module.scss';
import { ReactComponent as VLBetaLogo } from '../../../assets/img/VL-Beta-Logo.svg';

/**
 * Custom assistant message component with VL branding
 * Based on default AssistantMessage from CopilotKit
 */
const CustomAssistantMessage: React.FC<AssistantMessageProps> = (props) => {
  const { icons, labels } = useChatContext();
  const {
    message,
    isLoading,
    onRegenerate,
    onCopy,
    onThumbsUp,
    onThumbsDown,
    isCurrentMessage,
    markdownTagRenderers,
  } = props;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const content = message?.content || "";
    if (content && onCopy) {
      navigator.clipboard.writeText(content);
      setCopied(true);
      onCopy(content);
      setTimeout(() => setCopied(false), 2000);
    } else if (content) {
      navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleRegenerate = () => {
    if (onRegenerate) onRegenerate();
  };

  const handleThumbsUp = () => {
    // TODO: VL-6033 - This is a temporary hack to populate the input with feedback template.
    // Should be properly integrated with CopilotKit's input management system.
    const inputElement = document.querySelector('.copilotKitInput textarea') as HTMLTextAreaElement;
    if (inputElement) {
      const feedbackMessage = "+feedback: What made you smile?";
      // Set the value
      inputElement.value = feedbackMessage;
      // Trigger input event to update React state
      const event = new Event('input', { bubbles: true });
      inputElement.dispatchEvent(event);
      // Focus and select placeholder
      inputElement.focus();
      // Select the question text for easy replacement
      const placeholderStart = feedbackMessage.indexOf('What');
      const placeholderEnd = feedbackMessage.length;
      inputElement.setSelectionRange(placeholderStart, placeholderEnd);
    } else {
      console.warn('Could not find CopilotKit input textarea for feedback template');
    }
    // Call original handler if provided
    if (onThumbsUp && message) onThumbsUp(message);
  };

  const handleThumbsDown = () => {
    // TODO: VL-6033 - This is a temporary hack to populate the input with feedback template.
    // Should be properly integrated with CopilotKit's input management system.
    const inputElement = document.querySelector('.copilotKitInput textarea') as HTMLTextAreaElement;
    if (inputElement) {
      const feedbackMessage = "-feedback: Where's the bug hiding?";
      // Set the value
      inputElement.value = feedbackMessage;
      // Trigger input event to update React state
      const event = new Event('input', { bubbles: true });
      inputElement.dispatchEvent(event);
      // Focus and select placeholder
      inputElement.focus();
      // Select the question text for easy replacement
      const placeholderStart = feedbackMessage.indexOf('Where');
      const placeholderEnd = feedbackMessage.length;
      inputElement.setSelectionRange(placeholderStart, placeholderEnd);
    } else {
      console.warn('Could not find CopilotKit input textarea for feedback template');
    }
    // Call original handler if provided
    if (onThumbsDown && message) onThumbsDown(message);
  };

  const LoadingIcon = () => <span>{icons.activityIcon}</span>;
  const content = message?.content || "";
  const subComponent = message?.generativeUI?.();

  return (
    <>
      {content && (
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <div className={styles.avatar}>
              <VLBetaLogo width="24" height="24"/>
            </div>
            <div className={styles.messageWrapper}>
              <div className="copilotKitMessage copilotKitAssistantMessage">
                {content && <Markdown content={content} components={markdownTagRenderers} />}

                {content && !isLoading && (
                  <div
                    className={`copilotKitMessageControls ${isCurrentMessage ? "currentMessage" : ""}`}
                  >
                    <button
                      className="copilotKitMessageControlButton"
                      onClick={handleRegenerate}
                      aria-label={labels.regenerateResponse}
                      title={labels.regenerateResponse}
                    >
                      {icons.regenerateIcon}
                    </button>
                    <button
                      className="copilotKitMessageControlButton"
                      onClick={handleCopy}
                      aria-label={labels.copyToClipboard}
                      title={labels.copyToClipboard}
                    >
                      {copied ? (
                        <span style={{ fontSize: "10px", fontWeight: "bold" }}>✓</span>
                      ) : (
                        icons.copyIcon
                      )}
                    </button>
                    {onThumbsUp && (
                      <button
                        className="copilotKitMessageControlButton"
                        onClick={handleThumbsUp}
                        aria-label={labels.thumbsUp}
                        title={labels.thumbsUp}
                      >
                        {icons.thumbsUpIcon}
                      </button>
                    )}
                    {onThumbsDown && (
                      <button
                        className="copilotKitMessageControlButton"
                        onClick={handleThumbsDown}
                        aria-label={labels.thumbsDown}
                        title={labels.thumbsDown}
                      >
                        {icons.thumbsDownIcon}
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div style={{ marginBottom: "0.5rem" }}>{subComponent}</div>
      {isLoading && <LoadingIcon />}
    </>
  );
};

export default CustomAssistantMessage;